// extracted by mini-css-extract-plugin
export default {"root":"Page404_root__B63xM"};